/**
 * Locale for every `Intl` formatter in the portal.
 *
 * Fixed (not the browser default) so a shared report link shows the same figures on every
 * machine — separators and fraction rules do not depend on who opened the tab.
 *
 * `en-US` and `en-GB` format plain numbers identically (`1,234.56`); the pin is for consistency,
 * not for a regional number style. Change it here only.
 */
export type SupportedLocale = 'en' | 'zh-CN' | 'vi';

const FORMAT_LOCALES: Record<SupportedLocale, string> = {
  en: 'en-US',
  'zh-CN': 'zh-CN',
  vi: 'vi-VN',
};

/** Live binding so existing formatter call sites follow the authenticated profile locale. */
export let LOCALE = FORMAT_LOCALES.en;

export function setLocale(locale: SupportedLocale): void {
  LOCALE = FORMAT_LOCALES[locale];
}
